import type { RootStateType } from '@/features/store';

const choiceSelector = (state: RootStateType) => state.choice;

export default choiceSelector;
